import {Device}										from '../../redux/devices/interface';
import {User}										from '../../redux/user/interface';
import {Catalog, CatalogMinimal,
	CatalogSortCategories}							from '../../redux/catalog/interface';
import {Contract, Funder}							from '../../redux/contracts/interface';
import {DeviceStatus, LanguageType}					from '../language/type';
import {ImageFormat}								from '../typescript-declaration/global';

import {ft_getFunderFromContract}					from './findFromContract';

import fr											from '../language/fr';

import img_computer									from '../images/icon/devices/computer.svg';
import img_phone									from '../images/icon/devices/phone-2.svg';
import img_tablet									from '../images/icon/devices/tablet-2.svg';
import img_hub										from '../images/icon/devices/hub.svg';
import img_headphones								from '../images/icon/devices/headphones.svg';
import img_keyboard									from '../images/icon/devices/keyboard.svg';
import img_screen									from '../images/icon/devices/screen.svg';
import img_mouse									from '../images/icon/devices/mouse.svg';
import img_speaker									from '../images/icon/devices/speaker.svg';

import {DEVICE_TYPE}								from '../data/form';

const URL = 'https://valala-ressource.s3.eu-west-3.amazonaws.com/';

export function ft_getDeviceStatus(device: Device | undefined, users: (User | undefined)[]): keyof DeviceStatus {
	let finalStatus: keyof DeviceStatus = 'active';

	if (!device)
		return finalStatus;

	if (device.notValala && device.status)
		return device.status as keyof DeviceStatus;

	const company = users.find(find => find?.company)?.company;

	if (device.status === 'stock' || device.status === 'replacement' || device.status === 'repair')
		finalStatus = device.status;
	else if (!device.user || !users.find(find => find?._id === device.user))
		finalStatus = 'stock';

	if (device && (!device.company || (company && device.company !== company)))
		finalStatus = 'locationEnd';

	return finalStatus;
}

// const toStyle: (url?: string) => React.CSSProperties = url => ({backgroundImage: `url('${url}')`});

export function ft_getDeviceImageByString(type: string | undefined) {
	if (type === 'phone' || type === fr.global.phone)
		return img_phone;
	else if (type === 'tablet' || type === fr.global.tablet)
		return img_tablet;
	else if (type === 'hub' || type === fr.global.hub)
		return img_hub;
	else if (type === 'headphones' || type === fr.global.headphones)
		return img_headphones;
	else if (type === 'keyboard' || type === fr.global.keyboard)
		return img_keyboard;
	else if (type === 'screen' || type === fr.global.screen)
		return img_screen;
	else if (type === 'mouse' || type === fr.global.mouse)
		return img_mouse;
	else if (type === 'speaker' || type === fr.global.speaker)
		return img_speaker;
	return img_computer;
}

export function ft_getDeviceImage(device?: Device, format: ImageFormat = 'thumbnail', forceIndex = 0) {
	if (device?.shopData)
		return ft_getCatalogDeviceImage(device.shopData, format, forceIndex);
	return ft_getDeviceImageByString(device?.notValalaData?.deviceType);
}

export function ft_getCatalogDeviceImage(catalog?: Catalog | CatalogMinimal | CatalogSortCategories | Record<string, never>, format: ImageFormat = 'thumbnail', forceIndex = 0) {
	if (catalog?.image?.[forceIndex] || catalog?.image?.[0]) {
		if (!catalog.image[forceIndex])
			forceIndex = 0;

		if (catalog.image[forceIndex]?.formats?.[format]?.key)
			return `${URL}${catalog.image[forceIndex]?.formats?.[format].key}` || ft_getDeviceImageByString(catalog?.type);
		return `${URL}${catalog.image[forceIndex]?.key}` || ft_getDeviceImageByString(catalog?.type);
	}

	return ft_getDeviceImageByString(catalog?.type);
}

export function ft_getDeviceName(device: Device) : string {
	if (!device)
		return '';
	return device.shopData?.name || device.name;
}

export function ft_getDevicePrice(device: Device, allContracts: Contract[]) : (number | string) {
	if (!device || !allContracts)
		return '??';

	if (device.notValala)
		return device.notValalaData?.price || '??';

	let contract: Contract | undefined;
	let contractFunder: Funder | undefined;

	if (typeof device.contract === 'object')
		contract = device.contract;
	else if (device.contract)
		contract = allContracts.find(find => find?._id === device.contract);
	else {
		contract = allContracts.find(find =>
			find.funderList.some(findFunder =>
				findFunder.devices.some(findDevice => findDevice.device._id === device._id)
			)
		);
	}

	if (contract)
		contractFunder = ft_getFunderFromContract(device._id, contract);

	const deviceContract = contractFunder?.devices.find(find => find.device._id === device._id);

	if (typeof deviceContract?.price === 'number')
		return deviceContract?.price || '0';
	return '??';
}

export function ft_getDeviceCatalogPrice(catalog: Catalog, duration = 36): number {
	if (!catalog)
		return 0;

	if (duration !== 36) {
		const findPrice = catalog.extendedPrice?.find(find => find.month === duration);

		if (findPrice)
			return parseFloat(`${findPrice.price}`);
	}

	return parseFloat(`${catalog?.info?.price || catalog.price}`) || 0;
}

export function ft_getDeviceType(device?: Device, type?: string) : string {
	let typeValue = device?.shopData?.type || device?.notValalaData?.deviceType || type;

	if (!typeValue)
		return '';

	if (typeValue === 'mobile')
		typeValue = 'phone';

	const check = (name: keyof LanguageType['global']) => (
		typeValue === name || typeValue === fr.global[name]
	);

	if (check('phone'))
		return 'phone';
	else if (check('tablet'))
		return 'tablet';
	else if (check('hub'))
		return 'hub';
	else if (check('headphones'))
		return 'headphones';
	else if (check('keyboard'))
		return 'keyboard';
	else if (check('screen'))
		return 'screen';
	else if (check('mouse'))
		return 'mouse';
	else if (check('speaker'))
		return 'speaker';
	else if (check('sim'))
		return 'sim';
	else if (check('other'))
		return 'other';
	return 'computer';
}

export function ft_getDeviceTypeName(TEXTE: LanguageType, type: string) : string {
	const typeValue = ft_getDeviceType(undefined, type);

	return DEVICE_TYPE(TEXTE).find(find => find.value === typeValue)?.render || '';
}

export function ft_deviceIsReplaced(device?: Device) : boolean {
	return !!device?.replacement?.replaceBy;
}